angular.module("aps.services.appInsights", [])
  .service("appInsightsService", appInsightsService);

function appInsightsService(environment, $window) {
  function initialize($transitions) {
    if (!environment.APP_INSIGHTS_KEY) {
      return;
    }

    var appInsights=$window.appInsights||function(config){
      function i(config){t[config]=function(){var i=arguments;t.queue.push(function(){t[config].apply(t,i)})}}var t={config:config},u=document,e=window,o="script",s="AuthenticatedUserContext",h="start",c="stop",l="Track",a=l+"Event",v=l+"Page",y=u.createElement(o),r,f;y.src=config.url||"https://az416426.vo.msecnd.net/scripts/a/ai.0.js";u.getElementsByTagName(o)[0].parentNode.appendChild(y);try{t.cookie=u.cookie}catch(p){}for(t.queue=[],t.version="1.0",r=["Event","Exception","Metric","PageView","Trace","Dependency"];r.length;)i("track"+r.pop());return i("set"+s),i("clear"+s),i(h+a),i(c+a),i(h+v),i(c+v),i("flush"),config.disableExceptionTracking||(r="onerror",i("_"+r),f=e[r],e[r]=function(config,i,u,e,o){var s=f&&f(config,i,u,e,o);return s!==!0&&t["_"+r](config,i,u,e,o),s}),t
    }({
      instrumentationKey: environment.APP_INSIGHTS_KEY
    });

    $window.appInsights=appInsights;

    if ($transitions) {
      $transitions.onSuccess({ }, function(transition) {
        var to = transition.$to();
        try {
          appInsights.trackPageView(to.name, null, transition.params('to'));
        }
        catch (e) {
          // ignore
        }
      });
    }
  }

  return {
    initialize: initialize
  };
}



// WEBPACK FOOTER //
// ./src/app/appInsightsConfig.js